import API from 'API';

const API_LIST = {
    GET_GAME_SETTINGS: '/users/game_settings',
};

export function getGameSettings(params) {
    return API.get(API_LIST.GET_GAME_SETTINGS);
}